// users.js

export const types = {
  SHOW_LOGIN: 'USERS.SHOWLOGIN',
  SHOW_REGISTER: 'USERS.SHOWREGISTER',
  LOGIN_FAILED: 'USERS.LOGIN_FAILED',
  REGISTER_FAILED: 'USERS.REGISTER_FAILED',
  REGISTERING: 'USERS.REGISTERING',
  GETTING_DETAILS: 'USERS.GETTING_DETAILS',
  GOT_DETAILS: 'USERS.GOT_DETAILS',
  LOGGED_IN: 'USERS.LOGGED_IN',
  LOGGED_OUT: 'USERS.LOGGED_OUT',
  LOGGING_IN: 'USERS.LOGGING_IN',
  SAVING: 'USERS.SAVING',
  GET_CREDITS_FAILED: 'USERS.GET_CREDITS_FAILED',
  GOT_CREDITS: 'USERS.GOT_CREDITS',
  PROMPTING_RECOVERY_EMAIL: 'USERS.PROMPTING_RECOVERY_EMAIL',
  SENDING_RECOVERY_EMAIL: 'USERS.SENDING_RECOVERY_EMAIL',
  SENT_RECOVERY_EMAIL: 'USERS.SENT_RECOVERY_EMAIL',
  SENDING_RECOVERY_EMAIL_FAILED: 'USERS.SENDING_RECOVERY_EMAIL_FAILED',
  PROMPTING_RECOVERY_CODE: 'USERS.PROMPTING_RECOVERY_CODE',
  SETTING_NEW_PASSWORD: 'USERS.SETTING_NEW_PASSWORD',
  SET_NEW_PASSWORD: 'USERS.SET_NEW_PASSWORD',
  SETTING_NEW_PASSWORD_FAILED: 'USERS.SETTING_NEW_PASSWORD_FAILED',
  PROMPTING_CHANGE_PASSWORD: 'USERS.PROMPTING_CHANGE_PASSWORD',
  CHANGING_PASSWORD: 'USERS.CHANGING_PASSWORD',
  CHANGE_PASSWORD: 'USERS.CHANGE_PASSWORD',
  CHANGE_PASSWORD_FAILED: 'USERS.CHANGE_PASSWORD_FAILED',
  DISPLAYING_MORE: 'USERS.DISPLAYING_MORE',
  DISPLAY_MORE: 'USERS.DISPLAY_MORE',
  DISPLAY_MORE_FAILED: 'USERS.DISPLAY_MORE_FAILED',
  RESETTING_DISPLAY_COUNT: 'USERS.RESETTING_DISPLAY_COUNT',
  RESET_DISPLAY_COUNT: 'USERS.RESET_DISPLAY_COUNT',
  RESETTING_DISPLAY_COUNT_FAILED: 'USERS.RESETTING_DISPLAY_COUNT_FAILED',
  RESET_NOTIFICATION_STATUS: 'USERS.RESET_NOTIFICATION_STATUS'
};

export const show_login = () => ({
  type: types.SHOW_LOGIN
});

export const show_register = () => ({
  type: types.SHOW_REGISTER
});

export const login_failed = () => ({
  type: types.LOGIN_FAILED
});

export const register_failed = () => ({
  type: types.REGISTER_FAILED
});

export const logout = () => ({
  type: types.LOGGED_OUT
});

export const registering = () => ({
  type: types.REGISTERING
});

export const logging_in = () => ({
  type: types.LOGGING_IN
});

export const logged_in = user => ({
  type: types.LOGGED_IN,
  user: user
});

export const saving = () => ({
  type: types.SAVING
});

export const getting_details = () => ({
  type: types.GETTING_DETAILS
});

export const get_credits_failed = () => ({
  type: types.GET_CREDITS_FAILED
});

export const got_details = details => ({
  type: types.GOT_DETAILS,
  ...details
});

export const got_credits = credits => ({
  type: types.GOT_CREDITS,
  credits
});

export const prompt_recovery_email = () => ({
  type: types.PROMPTING_RECOVERY_EMAIL
});

export const sending_recovery_email = () => ({
  type: types.SENDING_RECOVERY_EMAIL
});

export const sent_recovery_email = email => ({
  type: types.SENT_RECOVERY_EMAIL,
  email: email
});

export const send_recovery_email_failed = error => ({
  type: types.SENDING_RECOVERY_EMAIL_FAILED,
  error: error
});

export const prompt_recovery_code = () => ({
  type: types.PROMPTING_RECOVERY_CODE
});

export const setting_new_password = () => ({
  type: types.SETTING_NEW_PASSWORD
});

export const set_new_password = password => ({
  type: types.SET_NEW_PASSWORD,
  ...password
});

export const set_new_password_failed = error => ({
  type: types.SETTING_NEW_PASSWORD_FAILED,
  error: error
});

export const prompting_change_password = () => ({
  type: types.PROMPTING_CHANGE_PASSWORD
});

export const changing_password = () => ({
  type: types.CHANGING_PASSWORD
});

export const change_password = () => ({
  type: types.CHANGE_PASSWORD
});

export const change_password_failed = error => ({
  type: types.CHANGE_PASSWORD_FAILED,
  error: error
});

export const displaying_more = () => ({
  type: types.DISPLAYING_MORE
});

export const display_more = page => ({
  type: types.DISPLAY_MORE,
  page
});

export const display_more_failed = error => ({
  type: types.DISPLAY_MORE_FAILED,
  error: error
});

export const reset_notification_status = () => ({
  type: types.RESET_NOTIFICATION_STATUS
});



// WEBPACK FOOTER //
// ./src/store/actions/users.js